import { Badge } from '@/components/ui/badge';
import Footer from '@/pages/utils/Footer';
import React, { useState } from 'react';
import 'yet-another-react-lightbox/styles.css';
import Lightbox from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import ScrollToTop from '@/pages/utils/ScrollToTop';
import AnimatedPage from '@/pages/utils/AnimatedPage';
import ProjectNav from '@/pages/utils/ProjectNav';
import { ModeToggle } from '@/components/mode-toggle';

const images = import.meta.glob('/public/project/real/i2b/ss/*.webp', { eager: true });

export default function I2BPOS() {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const imageArray = Object.keys(images).map((key) => ({
    src: images[key]?.default || images[key],
    title: key.split('/').pop().replace('.webp', ''),
  }));

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setIsOpen(true);
  };

  return (
    <div>
      <ProjectNav />
      <ScrollToTop />
      <AnimatedPage>
        <div className="container mt-28 lg:mt-44 mb-12 lg:px-[400px]">
          <div className="mt-16 md:mt-24">
            <h1 className="text-4xl md:text-7xl font-semibold">Point Of Sale</h1>
            <h1 className="text-xl font-thin mt-2 opacity-60">I2B</h1>
            <p className="my-4 opacity-60 font-base">
              In my collaboration with I2B, I helped build their Point of Sale (POS) application
              and improve the user flow. Together, we created a dynamic in various styles and
              colors, while maintaining a seamless design system for the team to further develop.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 my-6 md:my-12">
            <Badge className='rounded-full text-sm px-2'>
              UI/UX Design
            </Badge>
            <Badge className='rounded-full text-sm px-2'>
              App Design
            </Badge>
            <Badge className='rounded-full text-sm px-2'>
              Flutter
            </Badge>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mt-1 md:mt-12 px-8 pb-24 pt-16">
          {imageArray.map((img, index) => (
            <div key={img.title} className="flex flex-col gap-1">
              <img
                src={img.src}
                alt={img.title}
                className="shadow-lg rounded-lg cursor-pointer"
                onClick={() => openLightbox(index)}
              />
              <p className="font-light text-xs text-stone-400 mt-2 capitalize">{img.title}</p>
            </div>
          ))}
        </div>
      </AnimatedPage>

      <div className='fixed bottom-12 right-12'>
        <ModeToggle />
      </div>

      {isOpen && (
        <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          slides={imageArray}
          index={currentImageIndex}
          plugins={[Captions]}
          on={{ view: ({ index }) => setCurrentImageIndex(index) }}
        />
      )}
    </div>
  );
}
